import { IUserEventData } from '@api/event';
import { httpExt } from './base-http-external';

export const sendUserEventExternalApi = (params: IUserEventData) =>
  httpExt.post(`/api/v1/user-event`, params);
